/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateSalesContactInput
 */
export interface CreateSalesContactInput {
  /**
   *
   * @type {string}
   * @memberof CreateSalesContactInput
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof CreateSalesContactInput
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateSalesContactInput
   */
  phoneNumber: string;
  /**
   *
   * @type {string}
   * @memberof CreateSalesContactInput
   */
  phoneExtension: string;
  /**
   *
   * @type {string}
   * @memberof CreateSalesContactInput
   */
  mobileNumber: string;
  /**
   *
   * @type {string}
   * @memberof CreateSalesContactInput
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof CreateSalesContactInput
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof CreateSalesContactInput
   */
  notes?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CreateSalesContactInput
   */
  makePrimary: boolean;
}

/**
 * Check if a given object implements the CreateSalesContactInput interface.
 */
export function instanceOfCreateSalesContactInput(
  value: object,
): value is CreateSalesContactInput {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("phoneNumber" in value) || value["phoneNumber"] === undefined)
    return false;
  if (!("phoneExtension" in value) || value["phoneExtension"] === undefined)
    return false;
  if (!("mobileNumber" in value) || value["mobileNumber"] === undefined)
    return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("description" in value) || value["description"] === undefined)
    return false;
  if (!("makePrimary" in value) || value["makePrimary"] === undefined)
    return false;
  return true;
}

export function CreateSalesContactInputFromJSON(
  json: any,
): CreateSalesContactInput {
  return CreateSalesContactInputFromJSONTyped(json, false);
}

export function CreateSalesContactInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateSalesContactInput {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    name: json["name"],
    phoneNumber: json["phoneNumber"],
    phoneExtension: json["phoneExtension"],
    mobileNumber: json["mobileNumber"],
    email: json["email"],
    description: json["description"],
    notes: json["notes"] == null ? undefined : json["notes"],
    makePrimary: json["makePrimary"],
  };
}

export function CreateSalesContactInputToJSON(
  json: any,
): CreateSalesContactInput {
  return CreateSalesContactInputToJSONTyped(json, false);
}

export function CreateSalesContactInputToJSONTyped(
  value?: CreateSalesContactInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    name: value["name"],
    phoneNumber: value["phoneNumber"],
    phoneExtension: value["phoneExtension"],
    mobileNumber: value["mobileNumber"],
    email: value["email"],
    description: value["description"],
    notes: value["notes"],
    makePrimary: value["makePrimary"],
  };
}
